import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, IconButton, Paper, Checkbox, Tabs, Tab, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Divider, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { ArrowBack, LibraryBooks, Edit, Delete, Add, CheckCircleOutlined, RadioButtonUnchecked, Save } from '@mui/icons-material';
import axios from 'axios';
import { API_URL } from './config';

const DEFAULT_ROTINA_DATA: Record<number, { title: string, tasks: string[] }> = {
  1: {
    title: 'Segunda-feira',
    tasks: [
      "Meu Boletim de Ponto",
      "Conferir se Materiais, insumos, formulário, larvicida para os ACEs estão disponíveis",
      "Programação e atualização do TOVIS (horário conveniente)",
      "Digitalizar outros quarteirões (se GPT disponível)",
      "FAD-01: Conferir",
      "FAD-01: Lançar na planilha",
      "FAD-01: Fazer upload",
      "Boletim de Campo Semanal",
      "Boletim de Campo Geral",
      "FAD-07 da semana anterior",
      "Há alguma solicitação para Coordenação?",
      "É fechamento de área? Acionar protocolo de Fechamento de Área",
      "Estudar Supervisão de campo"
    ]
  },
  2: {
    title: 'Terça-feira',
    tasks: [
      "Meu Boletim de Ponto",
      "Programação e atualização do TOVIS (horário conveniente)",
      "Digitalizar outros quarteirões (se GPT disponível)",
      "FAD-01: Conferir",
      "FAD-01: Lançar na planilha",
      "FAD-01: Fazer upload",
      "Acompanhamento de visita de campo pela manhã (se viável)",
      "Fechar folha de Boletim de Ponto da Semana anterior",
      "Análise de tubitos (se houver)",
      "Há alguma solicitação para Coordenação?",
      "É fechamento de área? Acionar protocolo de Fechamento de Área",
      "Estudar Supervisão de campo"
    ]
  },
  3: {
    title: 'Quarta-feira',
    tasks: [
      "Meu Boletim de Ponto",
      "Programação e atualização do TOVIS (horário conveniente)",
      "Digitalizar outros quarteirões (se GPT disponível)",
      "Acompanhamento de visita de campo pela manhã (se viável)",
      "FAD-01: Conferir",
      "FAD-01: Lançar na planilha",
      "FAD-01: Fazer upload",
      "11:00h - Levar Digitação: FAD-07 anterior, FAD-07 PE, Férias/Licença, Folhas de Ponto",
      "Há alguma solicitação para Coordenação?",
      "É fechamento de área? Acionar protocolo de Fechamento de Área",
      "Estudar Supervisão de campo"
    ]
  },
  4: {
    title: 'Quinta-feira',
    tasks: [
      "Ponto estratégico: Enviar ACE para P.E e informar Ciclo (se semana de P.E)",
      "Meu Boletim de Ponto",
      "Programação e atualização do TOVIS (horário conveniente)",
      "Digitalizar outros quarteirões (se GPT disponível)",
      "FAD-01: Conferir",
      "FAD-01: Lançar na planilha",
      "FAD-01: Fazer upload",
      "Análise de tubitos (se houver)",
      "Há alguma solicitação para Coordenação?",
      "É fechamento de área? Acionar protocolo de Fechamento de Área",
      "Estudar Supervisão de campo"
    ]
  },
  5: {
    title: 'Sexta-feira',
    tasks: [
      "Meu Boletim de Ponto",
      "Programação e atualização do TOVIS (horário conveniente)",
      "Digitalizar outros quarteirões (se GPT disponível)",
      "FAD-01: Conferir",
      "FAD-01: Lançar na planilha",
      "FAD-01: Fazer upload",
      "Conferir FAD-01 P.E",
      "Lançar FAD-01 P.E no TOVIS",
      "Boletim de Campo Geral de P.E (se houver)",
      "FAD-07 de P.E (se houver)",
      "Arrumar para Segunda: Materiais, insumos, formulário, larvicida",
      "Há alguma solicitação para Coordenação?",
      "É fechamento de área? Acionar protocolo de Fechamento de Área",
      "Estudar Supervisão de campo"
    ]
  }
};

const DAY_COLORS: Record<number, string> = {
  1: '#60a5fa', // Azul suave
  2: '#34d399', // Verde esmeralda suave
  3: '#fbbf24', // Amarelo/Ambar suave
  4: '#a78bfa', // Roxo suave
  5: '#2dd4bf'  // Teal suave
};

const getTodayIso = () => {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().split('T')[0];
};

export default function Rotina({ onVoltar, onNavegar }: { onVoltar: () => void, onNavegar: (p: string) => void }) {
  const [activeDay, setActiveDay] = useState<number>(1);
  const [checkedItems, setCheckedItems] = useState<Record<string, boolean>>({});
  
  const [rotinaData, setRotinaData] = useState<Record<number, { title: string, tasks: string[] }>>(() => {
    const saved = localStorage.getItem('tovis_rotina_defs');
    return saved ? JSON.parse(saved) : DEFAULT_ROTINA_DATA;
  });

  const [editMode, setEditMode] = useState(false);
  const [editingTaskIndex, setEditingTaskIndex] = useState<number | null>(null);
  const [editingTaskText, setEditingTaskText] = useState("");
  
  const [homeDados, setHomeDados] = useState<any>(null);

  useEffect(() => {
    let day = new Date().getDay();
    if (day === 0 || day === 6) day = 1;
    setActiveDay(day);
    
    const savedChecks = localStorage.getItem(`tovis_rotina_${getTodayIso()}`);
    if (savedChecks) {
      try { setCheckedItems(JSON.parse(savedChecks)); } catch (e) {}
    }
    
    axios.get(`${API_URL}/api/painel-home/dados`)
      .then(r => setHomeDados(r.data))
      .catch(e => console.error(e));
  }, []);

  const handleToggle = (taskIndex: number) => {
    if (editMode) return;
    const key = `${activeDay}-${taskIndex}`;
    const novo = { ...checkedItems, [key]: !checkedItems[key] };
    setCheckedItems(novo);
    localStorage.setItem(`tovis_rotina_${getTodayIso()}`, JSON.stringify(novo));
  };

  const saveRotinaDefs = (newData: any) => {
    setRotinaData(newData);
    localStorage.setItem('tovis_rotina_defs', JSON.stringify(newData));
  };

  const handleAddTask = () => {
    const newData = { ...rotinaData };
    newData[activeDay].tasks.push("Nova Tarefa (clique para editar)");
    saveRotinaDefs(newData);
  };

  const handleDeleteTask = (taskIndex: number) => {
    const newData = { ...rotinaData };
    newData[activeDay].tasks.splice(taskIndex, 1);
    saveRotinaDefs(newData);
  };

  const handleSaveEdit = () => {
    if (editingTaskIndex !== null) {
      const newData = { ...rotinaData };
      newData[activeDay].tasks[editingTaskIndex] = editingTaskText;
      saveRotinaDefs(newData);
      setEditingTaskIndex(null);
    }
  };

  const tasks = rotinaData[activeDay]?.tasks || [];
  const completedCount = tasks.filter((_, i) => checkedItems[`${activeDay}-${i}`]).length;
  const color = DAY_COLORS[activeDay] || '#00b8cc';
  
  const seAtual = homeDados?.pulso?.se_atual;
  const areaAtual = homeDados?.pulso?.area_em_campo;
  const isPE = seAtual && typeof seAtual === 'number' && seAtual % 2 !== 0;

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#030b16', color: '#e0e8f0' }}>
      {/* HEADER */}
      <Box sx={{ bgcolor: '#081629', borderBottom: `2px solid ${color}40`, px: { xs: 2, md: 4 }, py: 2, transition: 'border-color 0.4s' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', maxWidth: 1100, mx: 'auto', flexWrap: 'wrap', gap: 2 }}>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <IconButton onClick={onVoltar} sx={{ color }}>
              <ArrowBack />
            </IconButton>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, color: '#f0f4f8' }}>
                Rotina de Supervisão
              </Typography>
              <Typography variant="body2" sx={{ color: '#8b9eb0' }}>
                Gestão e acompanhamento diário
              </Typography>
            </Box>
          </Box>
          
          {homeDados && (
            <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>
              <Paper elevation={0} sx={{ bgcolor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', px: 1.5, py: 0.5, borderRadius: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography sx={{ fontSize: 11, color: '#8b9eb0', fontWeight: 600, textTransform: 'uppercase' }}>Área</Typography>
                <Typography sx={{ fontSize: 14, color: '#f0f4f8', fontWeight: 700 }}>{areaAtual || '—'}</Typography>
              </Paper>
              <Paper elevation={0} sx={{ bgcolor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', px: 1.5, py: 0.5, borderRadius: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography sx={{ fontSize: 11, color: '#8b9eb0', fontWeight: 600, textTransform: 'uppercase' }}>S.E.</Typography>
                <Typography sx={{ fontSize: 14, color: '#f0f4f8', fontWeight: 700 }}>{seAtual || '—'}</Typography>
              </Paper>
              <Paper elevation={0} sx={{ 
                 bgcolor: isPE ? 'rgba(224, 36, 43, 0.15)' : 'rgba(255,255,255,0.02)', 
                 border: isPE ? '1px solid rgba(224, 36, 43, 0.4)' : '1px solid rgba(255,255,255,0.05)', 
                 px: 1.5, py: 0.5, borderRadius: 2, display: 'flex', alignItems: 'center', gap: 1,
                 transition: 'all 0.3s'
              }}>
                <Typography sx={{ 
                   fontSize: 12, 
                   color: isPE ? '#ff4d4d' : 'rgba(255,255,255,0.2)', 
                   fontWeight: 700, 
                   letterSpacing: 1 
                }}>
                  {isPE ? '🔴 PONTO ESTRATÉGICO ATIVO' : '⚪ P.E. INATIVO (SEMANA PAR)'}
                </Typography>
              </Paper>
            </Box>
          )}
          
          <Box sx={{ display: 'flex', gap: 2, ml: 'auto' }}>
            <Button 
              variant={editMode ? "contained" : "outlined"}
              onClick={() => setEditMode(!editMode)}
              startIcon={editMode ? <Save /> : <Edit />}
              sx={{ 
                color: editMode ? '#fff' : color, 
                bgcolor: editMode ? color : 'transparent',
                borderColor: editMode ? color : `${color}50`, 
                textTransform: 'none', px: 2,
                '&:hover': { bgcolor: editMode ? `${color}dd` : `${color}15`, borderColor: color }
              }}
            >
              {editMode ? 'Concluir Edição' : 'Editar Rotina'}
            </Button>
            <Button 
              variant="contained" 
              startIcon={<LibraryBooks />}
              onClick={() => onNavegar('protocolos')}
              sx={{ 
                bgcolor: '#0c1c30', color: color, borderColor: `${color}50`, border: '1px solid', textTransform: 'none', px: 3,
                '&:hover': { bgcolor: `${color}15`, borderColor: color }
              }}
            >
              Protocolos
            </Button>
          </Box>
          
        </Box>
      </Box>

      <Box sx={{ maxWidth: 1100, mx: 'auto', mt: 3, px: { xs: 2, md: 4 }, pb: 8 }}>
        
        <Box sx={{ mb: 3, display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' }}>
          <Tabs 
            value={activeDay} 
            onChange={(e, val) => setActiveDay(val)}
            sx={{ 
              minHeight: 36,
              '& .MuiTabs-indicator': { backgroundColor: color, height: 3 },
              '& .MuiTab-root': { textTransform: 'none', minWidth: {xs: 80, sm: 100}, minHeight: 36, py: 1, color: '#8b9eb0', fontWeight: 500, transition: 'color 0.3s' },
              '& .Mui-selected': { color: `${color} !important`, fontWeight: 700 }
            }}
          >
            <Tab label="Segunda" value={1} />
            <Tab label="Terça" value={2} />
            <Tab label="Quarta" value={3} />
            <Tab label="Quinta" value={4} />
            <Tab label="Sexta" value={5} />
          </Tabs>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            {!editMode && (
              <Typography variant="body2" sx={{ color: color, fontWeight: 600, bgcolor: `${color}15`, px: 2, py: 0.5, borderRadius: 4 }}>
                {completedCount} / {tasks.length} Concluídas
              </Typography>
            )}
            {editMode && (
              <Button size="small" startIcon={<Add />} onClick={handleAddTask} sx={{ color: color, bgcolor: `${color}15`, '&:hover': { bgcolor: `${color}25` } }}>
                Adicionar Tarefa
              </Button>
            )}
          </Box>
        </Box>

        <Paper elevation={0} sx={{ bgcolor: '#0c1c30', border: `1px solid ${color}30`, borderRadius: 2, overflow: 'hidden' }}>
          <List disablePadding>
            {tasks.map((task, idx) => {
              const isChecked = !!checkedItems[`${activeDay}-${idx}`];
              return (
                <React.Fragment key={idx}>
                  <ListItem 
                    disablePadding 
                    secondaryAction={
                      editMode && (
                        <Box>
                           <IconButton edge="end" onClick={() => { setEditingTaskText(task); setEditingTaskIndex(idx); }} sx={{ color: '#8b9eb0', mr: 1 }}>
                             <Edit fontSize="small" />
                           </IconButton>
                           <IconButton edge="end" onClick={() => handleDeleteTask(idx)} sx={{ color: '#e0242b' }}>
                             <Delete fontSize="small" />
                           </IconButton>
                        </Box>
                      )
                    }
                  >
                    <ListItemButton 
                      onClick={() => handleToggle(idx)}
                      disableRipple={editMode}
                      sx={{ 
                        py: 1.5, px: 3,
                        cursor: editMode ? 'default' : 'pointer',
                        bgcolor: isChecked && !editMode ? `${color}08` : 'transparent',
                        transition: 'background-color 0.2s',
                        '&:hover': { bgcolor: editMode ? 'transparent' : `${color}15` }
                      }}
                    >
                      {!editMode && (
                        <ListItemIcon sx={{ minWidth: 44 }}>
                          <Checkbox
                            edge="start"
                            checked={isChecked}
                            icon={<RadioButtonUnchecked sx={{ color: '#4a5b70' }} />}
                            checkedIcon={<CheckCircleOutlined sx={{ color: color }} />}
                            disableRipple
                          />
                        </ListItemIcon>
                      )}
                      <ListItemText 
                        primary={task} 
                        sx={{ 
                          m: 0,
                          '& .MuiListItemText-primary': {
                            fontSize: '15px',
                            fontWeight: isChecked && !editMode ? 400 : 500,
                            color: isChecked && !editMode ? '#64748b' : '#e7eef7',
                            textDecoration: isChecked && !editMode ? 'line-through' : 'none',
                            transition: 'all 0.2s'
                          }
                        }} 
                      />
                    </ListItemButton>
                  </ListItem>
                  {idx < tasks.length - 1 && <Divider sx={{ borderColor: 'rgba(255,255,255,0.05)' }} />}
                </React.Fragment>
              );
            })}
            {tasks.length === 0 && (
              <Box sx={{ p: 4, textAlign: 'center', color: '#8b9eb0' }}>
                Nenhuma tarefa definida para este dia.
              </Box>
            )}
          </List>
        </Paper>
      </Box>

      {/* MODAL DE EDIÇÃO DE TAREFA */}
      <Dialog open={editingTaskIndex !== null} onClose={() => setEditingTaskIndex(null)} sx={{ '& .MuiDialog-paper': { bgcolor: '#0c1c30', color: '#f0f4f8', minWidth: 400 } }}>
        <DialogTitle>Editar Tarefa</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            multiline
            rows={3}
            value={editingTaskText}
            onChange={(e) => setEditingTaskText(e.target.value)}
            variant="outlined"
            sx={{ mt: 1, '& .MuiOutlinedInput-root': { color: '#f0f4f8', '& fieldset': { borderColor: 'rgba(255,255,255,0.2)' }, '&:hover fieldset': { borderColor: color }, '&.Mui-focused fieldset': { borderColor: color } } }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button onClick={() => setEditingTaskIndex(null)} sx={{ color: '#8b9eb0' }}>Cancelar</Button>
          <Button onClick={handleSaveEdit} variant="contained" sx={{ bgcolor: color, color: '#fff', '&:hover': { bgcolor: `${color}dd` } }}>
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
